import { Get } from "domain/infra/data/api";
import DomainConstants from "../../infra/data/domainConstants";
import { PerfilResponse } from "../../types/perfil/perfilResponse";

export class PerfilService {// extends ExemploService {
  constructor() {
    //super()
  }

  async GetAtivos(sistemaID: number): Promise<PerfilResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.perfil.getAtivos}?sistemaID=${sistemaID}`)
  }

}
